import React, { FC, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { EuiButtonEmpty } from '@elastic/eui'

import { useLazyGetTempKeyForAccountAndInvoiceHandleQuery } from 'api/rtkQueryApi/platform/accountsApi'
import config from 'app/config'
import { useWhiteLabel } from 'whiteLabel/WhiteLabelContext'

import { RootState } from '../app/rootReducer'

export interface ViewInvoiceLinkProps {
  invoiceHandle: string
  accountId?: string
}

const ViewInvoiceLink: FC<ViewInvoiceLinkProps> = ({ invoiceHandle, accountId }) => {
  const whiteLabel = useWhiteLabel()
  const { currentOrganization } = useSelector((state: RootState) => state.app)
  const [getTempKey, getTempKeyQuery] = useLazyGetTempKeyForAccountAndInvoiceHandleQuery()

  const onViewInvoiceClick = useCallback(async () => {
    if (!whiteLabel || !currentOrganization) {
      return
    }

    const tempKey = await getTempKey({ invoiceHandle: invoiceHandle, isAgency: whiteLabel.isAgencies() }, false).unwrap()
    window.open(`${config.api.BASEURL}invoice/${currentOrganization?.id}/${tempKey.invoiceHandle}?tempKey=${tempKey.tempKey}${accountId ? `&accountId=${accountId}` : ''}`, '_blank', 'noopener,noreferrer')
  }, [whiteLabel, getTempKey, accountId, invoiceHandle, currentOrganization])

  return (
    <EuiButtonEmpty onClick={onViewInvoiceClick} iconSize='s' iconSide='right' iconType='popout' isLoading={getTempKeyQuery.isFetching}>
      View Invoice
    </EuiButtonEmpty>
  )
}

export default ViewInvoiceLink
